import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { IPatientInfo } from '../../ipatient-info';

@Component({
  selector: 'app-address-details',
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './address-details.component.html',
  styleUrl: './address-details.component.scss'
})
export class AddressDetailsComponent {
  @Input() patientDetails: IPatientInfo | undefined;

  hasAddress(address: any): boolean {
    return !!(
      address?.address1 ||
      address?.address2 ||
      address?.area ||
      address?.taluka ||
      address?.district ||
      address?.pincode ||
      address?.state ||
      address?.country
    );
  }
  
}
